import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-029da91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NovoProfissional__DadosResp" }
const _hoisted_2 = { class: "NovoProfissional__Atributos" }
const _hoisted_3 = { class: "NovoProfissional__Caracteristicas" }
const _hoisted_4 = { class: "NovoProfissional__Capacidades" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import {
    ref,
    reactive,
    onUnmounted,
    computed,
    onMounted,
    ComputedRef
   } from "vue"
  import { storeToRefs } from "pinia"
  import router from "@/router"

  import { LPadrao } from "@/layouts"
  import { TNovoProfissional } from "@/components/Profissionais"
  import {
    OTrilhaDeNavegacao,
    ODadosNaoEncontrados,
    MBotoesRodape,
    IAlertaMensagem,
    MModalDeAlerta
  } from "@/components/Gerais"
  import {
    OUsuarioInformacoes,
    ODadosResponsabilidadeUsuario,
  } from "@/components/Usuarios"
  import {
    OCapacidadeValorLista,
    OCaracteristicaValorLista,
  } from "@/components/AtributoComValor"
  import { MenuItem } from "primevue/menuitem"
  import TabMenu from "primevue/tabmenu"
  import PButton from "primevue/button"

  import { estados } from "@/types/api"

  import {
    CriarProfissional,
    ListarProfissionais,
    ParamsProfissional,
    UsuarioRelacionado,
    UsuarioResponsavel,
  } from "@/repositorios/profissional/profissional.modelo"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"

  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"
  import { CapacidadesStore } from "@/store/atributos/capacidades/capacidades.store"
  import { usuariosStore } from "@/store/listaUsuarios"

  import { usarAtributosComValor } from "@/composable/UsarAtributosComValor/usarAtributosComValor"
  import useVuelidate from "@vuelidate/core"

  import { Anulavel, ModoDeFormulario, PerfilDeOrganizacao } from "@/types/gerais"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import {
    CapacidadeComValor,
    ListaDePeriodosDeConsumo,
  } from "@/types/capacidades"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarFoto } from "@/composable/UsarFoto/usarFoto"
  import * as fotoPadraoDeAvatar from "@/assets/pi-avatar.png"
  import { useI18n } from "vue-i18n"

  interface Props {
    id?: string
    teleportarPara?: "self"
  }

  interface AlertaComReset extends IAlertaMensagem {
    $reset(): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NovoProfissional',
  props: {
    id: null,
    teleportarPara: null
  },
  setup(__props: any) {

const props = __props as {
    id?: string
    teleportarPara?: "self"
  }

  const { t } = useI18n()

  const breadCrumbItems = ref<MenuItem[]>([])

  const home = ref<MenuItem>({
    label: "profissionais",
    icon: "pi pi-users",
    to: "/profissionais",
  })
  const itensTabMenu: MenuItem[] = [
    { label: t('dadosDeAcessoResponsabilidades') },
    { label: t('atributosParaAlocacaoDoProfissional') },
  ]

  let objetoDialog = reactive<AlertaComReset>({
    titulo: "",
    icone: "",
    visivel: false,
    conteudo: "",
    tipo: "padrao",
    $reset: function () {
      this.visivel = false
      this.titulo = ""
      this.icone = ""
      this.conteudo = ""
    },
  })

  
  const profissionalRepositorio = new ProfissionalRepositorio()
  const usuariosRepositorio = new UsuariosRepositorio()
  const exibirFormularioDeUsuario = ref<boolean>(false)
  const indexAtivo = ref<number>(1)
  const estagioDaRequisicao = ref(0)
  const carregandoAtributos = ref(true)
  const profissionalAtivo = ref(false)
  const idUsuarioRelacionado = ref<Anulavel<string>>(null)

  const nome = ref<string>("")
  const codigo = ref<string>("")
  const foto = ref<File>()
  const fotoUrl = ref<string | null>()
  const usuariosResponsaveis = ref<string[]>([])

  const { caracteristicas } = storeToRefs(CaracteristicaStore())
  const { listarCaracteristicas, resetarCaracteristicas } = CaracteristicaStore()
  const { capacidades } = storeToRefs(CapacidadesStore())
  const { listarCapacidades, resetarCapacidades } = CapacidadesStore()
  const { senha, email, perfilDeOrganizacao } = storeToRefs(usuariosStore())

  const { resetarUsuarios } = usuariosStore()
  const { leitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { colher, agruparValoresDe } = usarManipuladorObjetos()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const { converterOsValoresDataHoraParaString } = usarAtributosComValor()
  const { obterUrlFotoProfissional } = usarFoto()

  const lerProfissionais = leitor<
    ListarProfissionais<number>,
    ParamsProfissional
  >(profissionalRepositorio.listarProfissionaisFrontend, {})

  const atualizarProfissionalSemUsuario = escritor<
    { id: string },
    string,
    CriarProfissional
  >(profissionalRepositorio.atualizarProfissionalSemUsuario, [])

  const atualizarProfissionalComUsuario = escritor<
    { id: string },
    string,
    CriarProfissional
  >(profissionalRepositorio.atualizarProfissionalComUsuario, [])

  const criarProfissionalSemUsuario = escritor<
    { id: string },
    CriarProfissional
  >(profissionalRepositorio.criarProfissionalSemUsuario, [])

  const criarProfissionalComUsuario = escritor<
    { id: string },
    CriarProfissional
  >(profissionalRepositorio.criarProfissionalComUsuario, [])

  const alterarFotoProfissional = escritor<{ id: string }, string, FormData>(
    profissionalRepositorio.atualizarFotoProfissional,
    []
  )

  const alterarFotoUsuario = escritor<{ id: string }, string, FormData>(
    usuariosRepositorio.atualizarFotoUsuario,
    []
  )

  const mostrarAbaDeAcessoEResponsabilidades = computed(() => {
    return indexAtivo.value === 0
  })

  const mostrarAbaDeAlocacaoProfissional = computed(() => {
    return indexAtivo.value === 1
  })


  const submetendoNoProfissional = computed(() => {
    return (
      atualizarProfissionalComUsuario.resultado.status === "pendente" ||
      atualizarProfissionalSemUsuario.resultado.status === "pendente" ||
      criarProfissionalSemUsuario.resultado.status === "pendente" ||
      criarProfissionalComUsuario.resultado.status === "pendente"
    )
  })
  const modoDeFormulario: ComputedRef<ModoDeFormulario> = computed(() =>
    props.id ? "editar" : "criar"
  )
  const atualizarFoto = (arquivo: File): void => {
    foto.value = arquivo
  }
  const temUsuarioRelacionado = computed(() => !!idUsuarioRelacionado.value)

  const rotuloBotaoNegar = computed(() =>
    modoDeFormulario.value === "editar" ? t("voltar") : t("cancelar")
  )
  const escopoValidacao = "Novo_Profissional"
  const v$ = useVuelidate({ $scope: escopoValidacao })


  const definirBreadcrumb = () => {
    if (props.id) {
      return [
        {
          label: `${t("editar")} ${nome.value}`,
          to: `/usuarios/editar-usuario/${props.id}`,
        },
      ]
  } else {
      return [
        {
          label: t("criarNovoProfissional"),
          to: "/usuarios/novo-usuario",
        },
      ]
    }
  }
  const exibirFormCriarUsuario = () => {
    exibirFormularioDeUsuario.value = true
  }

  const cancelarFormulario = () => {
    if (modoDeFormulario.value === "criar") {
      const mensagem: IAlertaMensagem = {
        icone: "pi pi-exclamation-triangle",
        visivel: true,
        titulo: t("cancelarCriacaoDoProfissional"),
        conteudo: t("aoCancelarVocePerderaTodasAsInformacoesNaoSalvas"),
        tipo: "atencao",
      }

      exibirDialogCancelarCriacao(mensagem)
      return
    }

    router.push("/profissionais")
  }

  const configurarFormularioModoEditar = async (
    profissional: ListarProfissionais<number>
  ): Promise<void> => {
    nome.value = profissional.nome
    codigo.value = profissional.codigo
    profissionalAtivo.value = profissional.ativo
    usuariosResponsaveis.value = agruparValoresDe<UsuarioResponsavel>(
      profissional.usuariosResponsaveis,
      "id"
    )

    caracteristicas.value = profissional.listaDeAtributosCaracteristicaComValor
    capacidades.value = profissional.listaDeAtributosCapacidadeComValor

    if (profissional.urlFotoDeAvatar) {
      fotoUrl.value = await obterUrlFotoProfissional(profissional.urlFotoDeAvatar)
    }

    if (profissional.usuarioRelacionado) {
      email.value = profissional.usuarioRelacionado.email
      perfilDeOrganizacao.value = profissional.usuarioRelacionado
      .perfilDeOrganizacao as PerfilDeOrganizacao
      idUsuarioRelacionado.value = profissional.usuarioRelacionado.id
      exibirFormularioDeUsuario.value = true
    }
  }

  const montarProfissional = (): CriarProfissional => {
    caracteristicas.value = converterOsValoresDataHoraParaString(
      caracteristicas.value
    )

    const colherIdeValorDeCaracteristicas = caracteristicas.value.map(
      (item) => {
        const caracterisitica = { id: item["id"], valor: item["valor"] }

        if (item["tipoDeValor"] === "itens_de_lista") {
          caracterisitica["tipoDosValoresDaLista"] = "texto"
        }

        return caracterisitica
      }
    )

    const colherIdePeriodosDeConsumoDeCapacidades = colher<
      CapacidadeComValor<number>,
      { id: string; periodosDeConsumo: ListaDePeriodosDeConsumo<string> }
    >(capacidades.value, ["id", "periodosDeConsumo"])

    const usuarioRelacionado: UsuarioRelacionado = {
      id: "",
      email: email.value,
      nome: nome.value,
      senha: senha.value,
      perfilDeOrganizacao: perfilDeOrganizacao.value as PerfilDeOrganizacao,
    }

    return {
      nome: nome.value,
      codigo: codigo.value,
      idsUsuariosResponsaveis: usuariosResponsaveis.value,
      listaDeAtributosCaracteristicaComValor: colherIdeValorDeCaracteristicas,
      listaDeAtributosCapacidadeComValor:
        colherIdePeriodosDeConsumoDeCapacidades,
      usuarioRelacionado: usuarioRelacionado,
      ativo: true,
    }
  }


  const buscarDadosDoProfissional = async (idProfissional: string): Promise<void> => {
    estagioDaRequisicao.value = estados.PEDENTE

    lerProfissionais.sobrescreverParametros({
      "por-pagina": "1000",
      id: "igual." + idProfissional,
    })

    await lerProfissionais.executar()

    if (lerProfissionais.resultado.status === "sucesso") {
      await configurarFormularioModoEditar(lerProfissionais.resultado.dados[0])
      estagioDaRequisicao.value = estados.SUCESSO
    }

    if (lerProfissionais.resultado.status === "vazio") {
      onErro({
        resumo: t("profissionalNaoEncontrado"),
        detalhes: t("naoFoiPossivelEncontrarProfissional"),
      })
    }

    if (lerProfissionais.resultado.status === "erro") {
      estagioDaRequisicao.value = estados.ERRO
      onErro({
        resumo: t("erroAoBuscarProfissional"),
        detalhes: t("ocorreuUmErroAoBuscarProfissional"),
      })
    }
  }

  const submeterAlterarFotoProfissional = async (fotoDoProfissional: File, id: string): Promise<void> => {
    const formData = new FormData()
    formData.append("arquivos", fotoDoProfissional)

    alterarFotoProfissional.mudarArgumentos([id, formData])
    await alterarFotoProfissional.executar()
    if (alterarFotoProfissional.resultado.status === "erro") {
      onErro({
        resumo: t("ocorreuUmErroAoAlterarFotoDoProfissional"),
        detalhes: t("ocorreuUmErroAoAlterarFoto"),
      })
    }
  }

  const submeterAlterarFotoUsuarioRelacionado = async (
    fotoDoProfissional: File,
    id: string
  ): Promise<void> => {
    const formData = new FormData()
    formData.append("arquivos", fotoDoProfissional)

    alterarFotoUsuario.mudarArgumentos([id, formData])
    await alterarFotoUsuario.executar()
    if (alterarFotoUsuario.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoAlterarFoto"),
        detalhes: t("ocorreuUmErroAoAlterarFotoDoUsuarioDoProfissional"),
      })
    }
  }

  const definirEscritorAoCriarProfissional = (
    profissional: CriarProfissional
  ) => {
    const { email: emailUsuarioRelacionado, senha: senhaUsuarioRelacionado } =
      profissional.usuarioRelacionado!

    const formularioDeUsuarioEstaVazio =
      !emailUsuarioRelacionado || !senhaUsuarioRelacionado

    if (formularioDeUsuarioEstaVazio) {
      return criarProfissionalSemUsuario
    }

    return criarProfissionalComUsuario
  }

  const submeterCriarProfissional = async (profissional: CriarProfissional): Promise<void> => {
    const escritorDeCriacao = definirEscritorAoCriarProfissional(profissional)
    escritorDeCriacao.mudarArgumentos([profissional])
    await escritorDeCriacao.executar()

    if (escritorDeCriacao.resultado.status === "sucesso") {
      if (foto.value) {
        await submeterAlterarFotoProfissional(
          foto.value,
          escritorDeCriacao.resultado.dados.id
        )
      }
      onSucesso({
        resumo: t("profissionalCriado"),
        detalhes: `${nome.value} ${t('cadastradoComSucesso')}`,
      })
      router.push("/profissionais")
    }

    if (escritorDeCriacao.resultado.status === "erro") {
      onErro({
        resumo: t("naoFoiPossivelCriarProfissional"),
        detalhes: escritorDeCriacao.resultado.mensagem,
      })
    }
  }

  const redirecionarParaTabelaDeProfissionais = (): void => {
    router.push("/profissionais")
  }

  const submeterAtualizarProfissional = async (
    profissional: CriarProfissional
  ) => {
    const definirEscritorAoAtualizarProfissional = () => {
      const verificarSeFormularioDeUsuarioRelacionadoEstaVazio = () => {
        const {
          email: emailUsuarioRelacionado,
          perfilDeOrganizacao: perfilDeOrganizacaoUsuarioRelacionado,
        } = profissional.usuarioRelacionado!

        return (
          !emailUsuarioRelacionado || !perfilDeOrganizacaoUsuarioRelacionado
        )
      }

      const formularioDeUsuarioEstaVazio =
        verificarSeFormularioDeUsuarioRelacionadoEstaVazio()

      if (formularioDeUsuarioEstaVazio) {
        return atualizarProfissionalSemUsuario
      }

      return atualizarProfissionalComUsuario
    }

    const mostrarNotificacaoDeSucesso = (nomeDoProfissional: string): void => {
      onSucesso({
        resumo: t("profissionalAtualizado"),
        detalhes: `${nomeDoProfissional} ${t("atualizadoComSucesso")}`,
      })
    }

    const mostrarNotificacaoDeErro = (erro): void => {
      onErro({
        resumo: t("ocorreuUmErroAoAtualizarProfissional"),
        detalhes: erro,
      })
    }

    const darRetornoDeSucessoProUsuario = async (): Promise<void> => {
      const existeNovaFotoParaSalvar = foto.value !== fotoPadraoDeAvatar
      if (foto.value && existeNovaFotoParaSalvar) {
        await submeterAlterarFotoProfissional(foto.value, props.id!)
        if (idUsuarioRelacionado.value) {
          await submeterAlterarFotoUsuarioRelacionado(
            foto.value,
            idUsuarioRelacionado.value
          )
        }
      }
      mostrarNotificacaoDeSucesso(nome.value)
      redirecionarParaTabelaDeProfissionais()
    }

    const darRetornoDeErroProUsuario = (erro): void => {
      mostrarNotificacaoDeErro(erro)
    }

    const escritorDeAtualizacao = definirEscritorAoAtualizarProfissional()
    escritorDeAtualizacao.mudarArgumentos([props.id, profissional])
    await escritorDeAtualizacao.executar()

    resolver<{ id: string }>(escritorDeAtualizacao.resultado, {
      sucesso: darRetornoDeSucessoProUsuario,
      erro: (erro) => {
        darRetornoDeErroProUsuario(erro.mensagem)
      },
    })
  }

  const submeterProfissional = async (): Promise<void> => {
    v$.value.$touch()
    const osCamposEstaoValidos = await v$.value.$validate()

    if (!osCamposEstaoValidos) {
      onErro({
        resumo: t("camposInvalidos"),
        detalhes: t("preenchaOuCorrijaOsCamposAlertados"),
      })
      return
    }

    const profissional = montarProfissional()

    if (modoDeFormulario.value === "criar") {
      submeterCriarProfissional(profissional)
    } else {
      submeterAtualizarProfissional(profissional)
    }
  }
  const exibirDialogCancelarCriacao = (dialog: IAlertaMensagem): void => {
    for (let key in dialog) {
      objetoDialog[key] = dialog[key]
    }
  }

  const confirmarCancelamento = (): void => {
    resetarCaracteristicas()
    resetarCapacidades()
    usuariosStore().$reset()
    v$.value.$reset()
    objetoDialog.$reset()
    router.push("/profissionais")
  }

  const voltar = (): void => {
    objetoDialog.visivel = false
  }

  const listarAtributos = async (): Promise<void> => {
    carregandoAtributos.value = true
    await Promise.allSettled([listarCaracteristicas(), listarCapacidades()])
    carregandoAtributos.value = false
  }

  const carregarDadosModoEditar = async (): Promise<void> => {
    await buscarDadosDoProfissional(props.id!)
    await listarAtributos()
  }

  const carregarDadosModoCriar = async (): Promise<void> => {
    await listarAtributos()
  }

  onMounted(async () => {
    if (modoDeFormulario.value === "editar" && props.id) {
      await carregarDadosModoEditar()
    } else {
      await carregarDadosModoCriar()
    }

    breadCrumbItems.value = definirBreadcrumb()
  })


  onUnmounted(() => {
    resetarUsuarios()
    resetarCaracteristicas()
    resetarCapacidades()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), {
    class: "NovoProfissional",
    "data-testid": "NovoProfissional"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TNovoProfissional), null, {
        navegacao: _withCtx(() => [
          _createVNode(_unref(OTrilhaDeNavegacao), {
            "inicio-da-trilha": home.value,
            "itens-da-trilha": breadCrumbItems.value
          }, null, 8, ["inicio-da-trilha", "itens-da-trilha"])
        ]),
        perfil: _withCtx(() => [
          _createVNode(_unref(OUsuarioInformacoes), {
            codigo: codigo.value,
            "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((codigo).value = $event)),
            fotoUrl: fotoUrl.value,
            "onUpdate:fotoUrl": _cache[1] || (_cache[1] = ($event: any) => ((fotoUrl).value = $event)),
            nome: nome.value,
            "onUpdate:nome": _cache[2] || (_cache[2] = ($event: any) => ((nome).value = $event)),
            usuariosResponsaveis: usuariosResponsaveis.value,
            "onUpdate:usuariosResponsaveis": _cache[3] || (_cache[3] = ($event: any) => ((usuariosResponsaveis).value = $event)),
            "onUpdate:foto": atualizarFoto,
            class: "NovoProfissional__Usuarios",
            desativado: _unref(submetendoNoProfissional),
            "escopo-validacao": escopoValidacao,
            "teleportar-para": __props.teleportarPara,
            "tem-usuarios-responsaveis": true
          }, null, 8, ["codigo", "fotoUrl", "nome", "usuariosResponsaveis", "desativado", "teleportar-para"])
        ]),
        menuaba: _withCtx(() => [
          _createVNode(_unref(TabMenu), {
            activeIndex: indexAtivo.value,
            "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => ((indexAtivo).value = $event)),
            class: "NovoProfissional__TabMenu",
            "data-testid": "NovoProfissional__TabMenu",
            desabled: _unref(submetendoNoProfissional),
            model: itensTabMenu
          }, null, 8, ["activeIndex", "desabled"])
        ]),
        centro: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            (exibirFormularioDeUsuario.value)
              ? (_openBlock(), _createBlock(_unref(ODadosResponsabilidadeUsuario), {
                  key: 0,
                  "alteracao-de-senha": 
              _unref(modoDeFormulario) === 'editar' && _unref(temUsuarioRelacionado)
            ,
                  class: "NovoProfissional__Responsabilidades",
                  desativado: _unref(submetendoNoProfissional),
                  "escopo-validacao": escopoValidacao
                }, null, 8, ["alteracao-de-senha", "desativado"]))
              : (_openBlock(), _createBlock(_unref(ODadosNaoEncontrados), {
                  key: 1,
                  onOnAcao: exibirFormCriarUsuario,
                  class: "NovoProfissional__AdicionarUsuario",
                  "icone-avatar": "pi-user",
                  mensagem: _unref(t)('esseProfissionalNaoEstaLigadoUmUsuarioDeAcesso'),
                  "texto-botao": _unref(t)('adicionarUsuario')
                }, null, 8, ["mensagem", "texto-botao"]))
          ], 512), [
            [_vShow, _unref(mostrarAbaDeAcessoEResponsabilidades)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(OCaracteristicaValorLista), { carregando: carregandoAtributos.value }, null, 8, ["carregando"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(OCapacidadeValorLista), { carregando: carregandoAtributos.value }, null, 8, ["carregando"])
            ])
          ], 512), [
            [_vShow, _unref(mostrarAbaDeAlocacaoProfissional)]
          ])
        ]),
        rodape: _withCtx(() => [
          _createVNode(_unref(MBotoesRodape), {
            onCancelar: cancelarFormulario,
            onSalvar: submeterProfissional,
            carregando: _unref(submetendoNoProfissional),
            "rotulo-botao-negar": _unref(rotuloBotaoNegar)
          }, null, 8, ["carregando", "rotulo-botao-negar"])
        ]),
        modais: _withCtx(() => [
          _createVNode(_unref(MModalDeAlerta), {
            modelValue: _unref(objetoDialog).visivel,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(objetoDialog).visivel) = $event)),
            cabecalho: _unref(objetoDialog).titulo,
            "data-testid": "NovoProfissional__Alerta",
            icone: _unref(objetoDialog).icone,
            "teleportar-para": __props.teleportarPara,
            tipo: _unref(objetoDialog).tipo
          }, {
            conteudo: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(objetoDialog).conteudo), 1)
            ]),
            acoes: _withCtx(() => [
              _createVNode(_unref(PButton), {
                onClick: voltar,
                class: "NovoProfissional__Button p-button-text",
                "data-testid": "NovoProfissional__Voltar",
                label: _unref(t)('voltarEditar')
              }, null, 8, ["label"]),
              _createVNode(_unref(PButton), {
                onClick: confirmarCancelamento,
                class: "NovoProfissional__Button p-button-danger",
                "data-testid": "NovoProfissional__Cancelar",
                label: _unref(t)('simCancelar')
              }, null, 8, ["label"])
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue", "cabecalho", "icone", "teleportar-para", "tipo"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})